module.exports = __webpack_public_path__ + "static/media/rate-2.9c848365.svg";